import { useState } from "react";
import { size } from "lodash";
import {
  getTablesApi,
  addTableApi,
  updateTableApi,
  deleteTableApi,
  getTableApi,
  getTableByNumberApi,
  regenerateTableCodeApi,
  setTableGuestsApi,
  setTableCustomerApi,
  setTableDeliveryApi,
} from "../api/table";
import { useAuth } from "./";

export function useTable() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tables, setTables] = useState(null);
  const [table, setTable] = useState(null);

  const { auth } = useAuth();

  const getTables = async () => {
    try {
      setLoading(true);
      const response = await getTablesApi(auth.token);
      setLoading(false);
      setTables(response);
    } catch (error) {
      setLoading(false);
      setError(error);
    }
  };

  const addTable = async (data) => {
    try {
      setLoading(true);
      const result = await addTableApi(data, auth.token);
      setLoading(false);
      return result;
    } catch (error) {
      setLoading(false);
      setError(error);
      // El formulario muestra el motivo (ej. "Ya existe la Mesa 5 en Terraza").
      throw error;
    }
  };

  const updateTable = async (id, data) => {
    try {
      setLoading(true);
      const result = await updateTableApi(id, data, auth.token);
      setLoading(false);
      return result;
    } catch (error) {
      setLoading(false);
      setError(error);
      // El formulario muestra el motivo (ej. "Ya existe la Mesa 5 en Terraza").
      throw error;
    }
  };

  const deleteTable = async (id) => {
    try {
      setLoading(true);
      await deleteTableApi(id, auth.token);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(error);
    }
  };

  const getTable = async (idTable) => {
    try {
      setLoading(true);
      const response = await getTableApi(idTable, auth?.me?.id ? auth.token : null);
      setLoading(false);
      setTable(response);
    } catch (error) {
      setLoading(false);
      setError(error);
    }
  };

  const regenerateTableCode = async (id) => {
    try {
      return await regenerateTableCodeApi(id, auth.token);
    } catch (error) {
      setError(error);
    }
  };

  const isExistTable = async (tableNumber) => {
    try {
      const response = await getTableByNumberApi(tableNumber);
      if (size(response) === 0) throw Error();
      return true;
    } catch (error) {
      setError(error);
    }
  };

  const getTableByNumber = async (tableNumber) => {
    try {
      const response = await getTableByNumberApi(tableNumber);
      return response;
    } catch (error) {
      setError(error);
    }
  };

  return {
    loading,
    error,
    tables,
    table,
    getTables,
    addTable,
    updateTable,
    deleteTable,
    getTable,
    isExistTable,
    regenerateTableCode,
    getTableByNumber,
    setTableGuests: (id, guests, waiter) => setTableGuestsApi(id, guests, auth.token, waiter),
    setTableCustomer: (id, customerId) => setTableCustomerApi(id, customerId, auth.token),
    setTableDelivery: (id, channel, fee) => setTableDeliveryApi(id, channel, fee, auth.token),
  };
}
